const BootstrapFormError = ({ children }) => (
  <div className="form-text text-danger">{children}</div>
)

export default BootstrapFormError
